/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { baseUrl } from '@/constant/api';
import { NameSpace } from '@/constant/store';

import { RootState } from '@/types/state';

import { TAG_TYPES } from './tag-types/tag-types';

export const api = createApi({
	reducerPath: NameSpace.api,
	baseQuery: fetchBaseQuery({
		baseUrl,
		prepareHeaders: (headers, { getState }) => {
			const url = window.location.origin;
			const token = (getState() as RootState).user.user?.access_token;

			headers.set('X-Phs-From-User-Url', url);
			if (token) {
				headers.set('Authorization', `Bearer ${token}`);
			}
			return headers;
		},
	}),
	tagTypes: TAG_TYPES,
	endpoints: () => ({}),
});
